import React,{useState,useEffect} from 'react'
import FirmMain from './FirmMain'
import { useShangpingdingdanListQuery } from '../store/ReactWebSiteApi'
import { Table,Tag,Space} from 'antd';
import dayjs from 'dayjs';
function FirmOrderList() {
    const byxkh_id = JSON.parse(localStorage.getItem('firmLoginInfo'))?.byxkh_yh_kh_id;
    const {data,isSuccess} = useShangpingdingdanListQuery({dd_byxkh_id:byxkh_id},{refetchOnMountOrArgChange:1})    
    const [list, setList] = useState();
    useEffect(() => {
        if(isSuccess){            
            if(data.Status==='success'){
                const newArr = data.Result.map(item => {
                    const {dd_id:key,dd_eowg_name,dd_eowgg_name,dd_eowgt_name,dd_eowgts_name,dd_byxkh_name,dd_uname,dd_ctime,dd_xf_date,dd_dq_date,dd_xf_amount,dd_xf_num,dd_byxkh_id,dd_qy_id,dd_content   } = item;
                    return item = {key,dd_eowg_name,dd_eowgg_name,dd_eowgt_name,dd_eowgts_name,dd_byxkh_name,dd_uname,dd_ctime,dd_xf_date,dd_dq_date,dd_xf_amount,dd_xf_num,dd_byxkh_id,dd_qy_id,dd_content}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.dd_ctime;
                    let bTimeString = b.dd_ctime;
                    return aTimeString - bTimeString;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])   
    const columns = [                               
        {
            key: 'state',
            title: '编号/状态',
            render:(text,record) => {
                if (record.dd_dq_date && new Date(record.dd_dq_date) < new Date()) {
                    return<>{record.key} / <Tag color='red'>已过期</Tag></>
                }else{
                    return<>{record.key} / <Tag color='green'>未过期</Tag></>
                }
            }
        },                      
        {
            key: 'dd_eowg_name',
            title: '商品/规格',
            dataIndex:'dd_eowg_name',  
            render:(text,record) => {
                return <>{text} / {record.dd_eowgg_name}</>
            }
        },                                                         
        {
            key: 'dd_xf_date',
            title: '缴费/到期日期',            
            dataIndex: 'dd_xf_date',           
            render:(text,record) => {
                return <>{text} 至 {record.dd_dq_date}，剩余{dayjs(record.dd_dq_date).diff(dayjs(), 'day')}天</>
            }
        },        
        {
            key: 'dd_xf_amount',
            title: '缴费金额',            
            dataIndex: 'dd_xf_amount',           
        },
                          
        {
            key: 'time',
            title: '操作',
            render: (_,record) =><Space>
                <a>系统登录</a>
            </Space>
        },
           
    ]
    return (
        <FirmMain leftSelectedKeys={['order']}>
            <Table columns={columns} dataSource={list}></Table> 
        </FirmMain>
    )
}

export default FirmOrderList